import * as React from "react";
function LgIcon() {
    return React.createElement("path", { d: "M3.5 21.5001V4.50014H6.69233V2.38477H8.23075V4.50014H15.8077V2.38477H17.3076V4.50014H20.5V21.5001H3.5ZM4.99997 20.0001H19V10.3078H4.99997V20.0001ZM4.99997 8.80787H19V6.00012H4.99997V8.80787Z", fill: "currentColor" });
}
export default LgIcon;
//# sourceMappingURL=Lg.js.map